<template>
  <div>
    <v-data-table :hide-actions="true"  :headers="headers" :items="worker.briefcases">
      <template v-slot:items="props">
        <tr style="background-color: rgba(210,105,30,0.0)" :key="props.item.guid" @click="props.expanded = !props.expanded">
          <td>{{ props.item.open_date }}</td>
          <td>{{ props.item.close_date }}</td>
          <td>{{ props.item.status == 10 ? "Aktywna" : "Nieaktywna"}}</td>

          <td>
            <v-btn  @click="goToWorkersDocuments(props.item.guid)" small icon>
              <v-icon color="green darken-3">pageview</v-icon>
            </v-btn>
            <v-btn v-if="props.item.status == 10"  @click="closeBriefcase(props.item.guid)" small icon>
              <v-icon color="red darken-3">cancel</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger"
import SearchSort from "@/components/common/SearchSort"

export default {
  name: "Workers",
  components:{
    SearchSort
  },
  props: ['worker'],
  data(){
    return{
      expand: false,
      workerDialog: false,
      workerEdit:{},
      headers : [
        {text: 'Data otwarcia', value: 'open_date' },
        {text: 'Data zamkniecia', value: 'close_date'},
        {text: 'Status', value: 'status'},
        {text: 'Akcje'},
      ],
    }
  },
  methods: {
    goToWorkersDocuments(briefcaseGuid){
      this.$router.push({name: 'documents-briefcase', params : {briefcaseGuid}})
    },
    closeBriefcase(briefcaseGuid){
      this.$http.post(`document/briefcase/${briefcaseGuid}/close`)
          .then(() => {
            this.$emit('closed', {worker: this.worker, briefcaseGuid})
            Messenger.emitSuccess("Teczka została zamknięta")
          })
          .catch(() => Messenger.emitError("Problem z zamknięciem teczki"))
    }
  }
}
</script>

<style scoped>
.icon{
  cursor: pointer;
}
</style>